<template>
  <section class="documentZone">
      <vue-dropzone
        ref="documentAttachDropZone"
        id="attachDropzone"
        class="documentIcon"
        :include-styling="false"
        :options="dropzoneOptions"
        @vdropzone-complete="afterAttach"
      ></vue-dropzone>
      <p>Add Document</p>
  </section>
</template>

<script>
import { mapState } from "vuex";
import firebase from "@/firebase";
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";



export default {
  data: () => ({
    title: "",
    color: "",
    dropzoneOptions: {
      url: "https://httpbin.org/post",
      thumbnailWidth: 150,
      thumbnailHeight: 150,
      maxFilesize: 5,
      maxFiles: 9,
      duplicateCheck: true,
      addRemoveLinks: true,
    },
  }),

  components: {
    vueDropzone: vue2Dropzone,
  },

  computed: {
    ...mapState("upload", ["isAddingFolder"]),
    ...mapState("messageBoard", ["groupId"]),
  },

  methods: {
    async afterAttach(file) {
      this.$refs.documentAttachDropZone.removeAllFiles(true);
      try {
        const storageRef = firebase.storage().ref();
        var fileRef = "";
        //If the file is an image
        if (file["type"] === "image/jpeg" || file["type"] === "image/png") {
          fileRef = storageRef.child(`images/${file.name}.png`);
        } else {
          fileRef = storageRef.child(`files/${file.name}`);
        }
        await fileRef.put(file);
        const downloadURL = await fileRef.getDownloadURL();
        //Adds the file to the dropzone to be viewed
        this.$refs.imgDropZone.manuallyAddFile(file, downloadURL);
      } catch (error) {
        console.log(error);
      }
    },
  },

}
</script>

<style  scoped>
p{
    color: gray;
    font-size: 15px;
    align-content: center;
    align-self: center;
}
input{
  border-radius: 5px;
  border: 1px solid black;
}
.documentZone{
    display: flex;
    width: 150px;
    flex-direction: column;
    text-align: center;
    justify-content: center;
    margin: 15px;
}
.documentIcon{
    height: 200px;
    width: 150px;
    cursor: pointer;
    background-image: url("../../assets/Upload/addDocument.svg");

}
.exit{
    position: absolute;
    margin-right: 120px;
    font-size: 25px;
    background-color: #084d49;
    width: 38px;
    transform: rotate(45deg);
    align-self: center;
    border-radius: 20vw;
    color: white;
    cursor: pointer;
}
</style>